import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import jwt_decode from 'jwt-decode';

import HeaderBar from './components/HeaderBar';
import LoginPage from './pages/LoginPage';
import CardManagerPage from './pages/CardManagerPage';
import BuxferManagerPage from './pages/BuxferManagerPage'; // Import BuxferManagerPage
import RegistrationPage from './pages/RegistrationPage';
import ProfilePage from './pages/ProfilePage';
import HomePage from './pages/HomePage';
import AmexOffersPage from './pages/AmexOffersPage';
import BillingStatementPage from './pages/BillingStatementPage';
import BuxferNotSyncedAccountsPage from './pages/BuxferNotSyncedAccountsPage';
import BuxferAccountsPage from './pages/BuxferAccountsPage';
import SimpleFINAccountsPage from './pages/SimpleFINAccountsPage';
import BuxferSyncHistoryPage from './pages/BuxferSyncHistoryPage';

import { storageHandler } from './utils/storage_handler';
import AmexOffersDownloadPage from './pages/AmexOffersDownloadPage';
import CreditCardCustomerPage from './pages/CreditCardCustomerPage';
import CustomerRelationshipPage from './pages/CustomerRelationshipPage';
import BuxferSyncPage from './pages/BuxferSyncPage';
import SingleCustomerPage from './pages/SingleCustomerPage';
import SpendingReportPage from './pages/SpendingReportPage';
import GmailMessagesPage from './pages/GmailMessagesPage';

function PrivateRoute({ children }) {
  let navigate = useNavigate();
  const token = storageHandler.localStorageGet('token');
  const location = useLocation();

  useEffect(() => {
    if (token) {
      let decoded = jwt_decode(token);
      let isNotExpired = decoded.exp && decoded.exp > Date.now() / 1000;
      if (!isNotExpired) {
        storageHandler.localStorageDelete('token');
        navigate("/login");
      } else {
        // If usertype is 2 (normal user), ensure they cannot access routes
        // that are not allowed for type-2. If they try, send them back to '/'.
        if (decoded.usertype === 2) {
          const allowed = [
            '/',
            '/buxfer-management',
            '/buxfer-accounts',
            '/buxfer-sync-history',
            '/gmail-messages',
            '/customer-relationship'
          ];
          const pathname = location && location.pathname ? location.pathname : '/';
          const allowedMatch = allowed.some(p => pathname === p || pathname.startsWith(p + '/') || pathname.startsWith(p + '?') || pathname.startsWith(p));
          if (!allowedMatch) {
            navigate('/');
          }
        }
      }
    } else {
      navigate("/login");
    }
  }, [token, navigate]);

  return children;
}

function App() {
  return (
    <Router>
      <HeaderBar />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/registration" element={<RegistrationPage />} />
        <Route path="/card-management" element={<PrivateRoute><CardManagerPage /></PrivateRoute>} />
        <Route path="/amex-offers" element={<PrivateRoute><AmexOffersPage /></PrivateRoute>} />
        <Route path="/amex-offers-downloads" element={<PrivateRoute><AmexOffersDownloadPage /></PrivateRoute>} />
        <Route path="/" element={<PrivateRoute><HomePage /></PrivateRoute>} />
        <Route path="/buxfer-management" element={<PrivateRoute><BuxferManagerPage /></PrivateRoute>} />
        <Route path="/buxfer/not-synced/:userName" element={<PrivateRoute><BuxferNotSyncedAccountsPage /></PrivateRoute>} />
        <Route path="/profile" element={<PrivateRoute><ProfilePage /></PrivateRoute>} />
        <Route path="/billing-statements" element={<PrivateRoute><BillingStatementPage /></PrivateRoute>} />
        <Route path="/customers-credit-card" element={<PrivateRoute><CreditCardCustomerPage /></PrivateRoute>} />
        <Route path="/customer-relationship" element={<PrivateRoute><CustomerRelationshipPage /></PrivateRoute>} />
        <Route path="/single-customer/:customer_code" element={<PrivateRoute><SingleCustomerPage /></PrivateRoute>} />
        <Route path="/buxfer-sync" element={<PrivateRoute><BuxferSyncPage /></PrivateRoute>} />
        <Route path="/buxfer-accounts" element={<PrivateRoute><BuxferAccountsPage /></PrivateRoute>} />
        <Route path="/simplefin-accounts" element={<PrivateRoute><SimpleFINAccountsPage /></PrivateRoute>} />
        <Route path="/buxfer-sync-history" element={<PrivateRoute><BuxferSyncHistoryPage /></PrivateRoute>} />
        <Route path="/spending-report" element={<PrivateRoute><SpendingReportPage /></PrivateRoute>} />
        <Route path="/gmail-messages" element={<PrivateRoute><GmailMessagesPage /></PrivateRoute>} />
      </Routes>
    </Router>
  );
}

export default App;
